const getUserScope = (authState) =>
  authState?.user?.id ??
  authState?.user?.userId ??
  authState?.user?.username ??
  authState?.user?.email ??
  "default";

const getStorageKey = (webPageKey, authState) =>
  webPageKey ? `columnVisibility_${webPageKey}_${getUserScope(authState)}` : null;

export const readColumnVisibility = (webPageKey, authState) => {
  const key = getStorageKey(webPageKey, authState);
  if (!key) return null;

  try {
    const saved = window.localStorage.getItem(key);
    if (!saved) return null;

    const visibility = JSON.parse(saved);
    if (visibility && typeof visibility === "object" && !Array.isArray(visibility)) {
      return visibility;
    }
  } catch {
    // Storage can be unavailable or contain an old, invalid value.
  }

  return null;
};

export const applyColumnVisibility = (columns, webPageKey, authState) => {
  const visibility = readColumnVisibility(webPageKey, authState);
  if (!visibility || !Array.isArray(columns)) return columns;

  return columns.map((group) => ({
    ...group,
    children: group.children?.map((column) =>
      !column.hideFromPicker &&
      typeof visibility[column.fldName] === "boolean"
        ? { ...column, isVisible: visibility[column.fldName] }
        : column
    ),
  }));
};

export const saveColumnVisibility = (columns, values, webPageKey, authState) => {
  if (!Array.isArray(columns)) return;

  const visibility = {};
  columns.forEach((group) => {
    group.children?.forEach((column) => {
      if (
        !column.hideFromPicker &&
        column.fldName &&
        typeof values?.[column.fldName] === "boolean"
      ) {
        visibility[column.fldName] = values[column.fldName];
      }
    });
  });

  writeColumnVisibility(webPageKey, authState, visibility);
};

export const writeColumnVisibility = (webPageKey, authState, visibility) => {
  const key = getStorageKey(webPageKey, authState);
  if (!key) return;

  try {
    window.localStorage.setItem(key, JSON.stringify(visibility));
  } catch {
    // The grid still works when local storage is disabled or full.
  }
};
